import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useMyMemu = (userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [menuList, setMenuList] = useState<MyMenuCheckDto[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.menu, [userid]],
    () =>
      fetcher.mypage.postMyMenuInfo({pm: String(userid)}),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setMenuList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, menuList, refetch };
};

export default useMyMemu;
